import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchErrorReports } from "../../services/errorReports";
import { STATUS } from "../../constants";

export const getErrorReports = createAsyncThunk("errorReports/fetchErrorReports", async () => {
  const response = await fetchErrorReports();
  return response.data;
});

const errorReportSlice = createSlice({
  name: "error_reports",
  initialState: { data: [], status: STATUS.DEFAULT },
  reducers: {},
  extraReducers: {
    [getErrorReports.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.status = STATUS.SUCCEED;
    },
    [getErrorReports.rejected]: (state) => {
      state.status = STATUS.FAILED;
    },
    [getErrorReports.pending]: (state) => {
      state.status = STATUS.LOADING;
    },
  },
});

export default errorReportSlice;
